import {Injectable} from '@angular/core';
import {PaginatedSearchRequest, PaginatedSearchResponse} from "src/app/model/pagination/pagination";
import {AppResponse} from "./app-response.model";
import {Account, AccountQuery} from "src/app/auth/auth.model";
import {Observable} from "rxjs";
import {optimistic} from "./common-http.service";
import {AuthHttpService} from "./auth-http.service";

@Injectable({
  providedIn: 'root'
})
export class AccountsApiService {

  constructor(
    private authHttp: AuthHttpService
  ) {
  }

  getAll(): Observable<Array<Account>> {
    return this.authHttp.get<Array<Account>>("/accounts").pipe(optimistic);
  }

  getGroupAccounts(): Observable<Array<Account>> {
    return this.authHttp.get<Array<Account>>("/accounts/group").pipe(optimistic);
  }

  isGroupAccount(): Observable<boolean> {
    return this.authHttp.get<boolean>("/accounts/group/value").pipe(optimistic);
  }

  search(search: PaginatedSearchRequest<AccountQuery>): Observable<PaginatedSearchResponse<Account>> {
    return this.authHttp.post<PaginatedSearchResponse<Account>>("/accounts/search", search).pipe(optimistic);
  }

  save(account: Account): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/accounts", account);
  }

  update(account: Account): Observable<AppResponse<void>> {
    return this.authHttp.put<void>("/accounts/" + account.id, account);
  }

  getReturn(): Observable<boolean> {
    return this.authHttp.get<boolean>("/accounts/return/get").pipe(optimistic);
  }

  switchReturn(): Observable<AppResponse<void>> {
    return this.authHttp.put<void>("/accounts/return/switch", "Switch Return");
  }

  getInform(): Observable<boolean> {
    return this.authHttp.get<boolean>("/accounts/inform/get").pipe(optimistic);
  }

  switchInform(): Observable<AppResponse<void>> {
    return this.authHttp.put<void>("/accounts/inform/switch", "Switch Inform");
  }

  getEmail(): Observable<AppResponse<string>> {
    return this.authHttp.get<string>("/accounts/email/get");
  }

  editEmail(email: string): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/accounts/email/edit", email);
  }

  getBasicConfiguration(): Observable<AppResponse<string>> {
    return this.authHttp.get<string>("/accounts/basic/get");
  }

  switchBasicConfiguration(): Observable<AppResponse<void>> {
    return this.authHttp.put<void>("/accounts/basic/switch", "Switch Basic Configuration");
  }

  getDegree(): Observable<number> {
    return this.authHttp.get<number>("/accounts/degree/get").pipe(optimistic);
  }

  setDegree(degree: number): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/accounts/degree/set", degree);
  }

  getHsa(): Observable<number> {
    return this.authHttp.get<number>("/accounts/hsa/get").pipe(optimistic);
  }

  setHsa(hsa: number): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/accounts/hsa/set", hsa);
  }

  setApex(id: number, value: boolean): Observable<AppResponse<void>> {
    return this.authHttp.put<void>(`/accounts/${id}/apex`, { value });
  }

  setBeta(id: number, value: boolean): Observable<AppResponse<void>> {
    return this.authHttp.put<void>(`/accounts/${id}/beta`, { value });
  }

  getApex(id: number): Observable<boolean> {
    return this.authHttp.get<boolean>(`/accounts/${id}/apex`).pipe(optimistic);
  }

  getBeta(id: number): Observable<boolean> {
    return this.authHttp.get<boolean>(`/accounts/${id}/beta`).pipe(optimistic);
  }
}
